<app-side-menu>
  <div class="template-editor-content">
    <div class="row mb-3">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div>
          <h1 class="page-title">
            <i class="fas fa-pen-to-square me-3"></i>
            Editar Template #{{ templateId }} (versão {{ versionId }})
          </h1>
          <p class="page-subtitle">Edite o documento e salve como nova versão (.docx)</p>
        </div>
        <div>
          <button class="btn btn-outline-secondary me-2" (click)="cancel()" [disabled]="isSaving">
            <i class="fas fa-times me-2"></i>Cancelar
          </button>
          <button class="btn btn-success" (click)="save()" [disabled]="isSaving || isLoading">
            <i class="fas fa-save me-2"></i>{{ isSaving ? 'Salvando...' : 'Salvar nova versão' }}
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="editor-wrapper">
          <div *ngIf="isLoading">Carregando documento...</div>
          <div *ngIf="!isLoading && loadError" class="alert alert-warning">
            {{ loadError }}
            <div class="mt-2">
              <button class="btn btn-sm btn-secondary me-2" (click)="downloadCurrent()">Baixar arquivo original</button>
              <button class="btn btn-sm btn-outline-secondary" (click)="router.navigate(['/documents/templates', templateId])">Voltar</button>
            </div>
          </div>
          <textarea *ngIf="!isLoading && !loadError" id="docxEditor"></textarea>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>


